import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'IronScales/Dashboard/Home/Deepfake'

export const GET_DEEPFAKE_ANALYTIC_ASYNC = createAsyncTypes('GET_DEEPFAKE_ANALYTIC', typeKey)
